import { FC, useEffect } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { PERIOD_END_REPORT_LIST } from 'adminConstants/routes';
import { useLayoutContext } from 'contexts/LayoutContext';
import api from 'lib/trpcClient';
import AddEditPeriodEndReport from './AddEditPeriodEndReport';

type AddPeriodEndReportProps = {
  vehicleId: string;
  accountingPeriodId: string;
};

type CreatedPeriodEndReportProps = {
  vehicleId: string;
  periodEndReportId: string;
};

const CreatedPeriodEndReport: FC<CreatedPeriodEndReportProps> = ({
  vehicleId,
  periodEndReportId,
}) => {
  const [periodEndReport] = api.periodEndReport.getById.useSuspenseQuery({
    vehicleId,
    id: periodEndReportId,
  });

  return <AddEditPeriodEndReport periodEndReport={periodEndReport} />;
};

const NewPeriodEndReport: FC<AddPeriodEndReportProps> = ({
  vehicleId,
  accountingPeriodId,
}) => {
  const [periodEndReport] = api.periodEndReport.getFormData.useSuspenseQuery({
    vehicleId,
    accountingPeriodId,
  });

  return <AddEditPeriodEndReport periodEndReport={periodEndReport} />;
};

const AddPeriodEndReport: FC<AddPeriodEndReportProps> = ({
  vehicleId,
  accountingPeriodId,
}) => {
  const { search } = useLocation<{ periodEndReportId?: string }>();
  const params = new URLSearchParams(search);
  const periodEndReportId = params.get('periodEndReportId');

  if (periodEndReportId) {
    return (
      <CreatedPeriodEndReport
        vehicleId={vehicleId}
        periodEndReportId={periodEndReportId}
      />
    );
  }

  return (
    <NewPeriodEndReport
      vehicleId={vehicleId}
      accountingPeriodId={accountingPeriodId}
    />
  );
};

type EditPeriodEndReportProps = {
  vehicleId: string;
  id: string;
};

const EditPeriodEndReport: FC<EditPeriodEndReportProps> = ({
  vehicleId,
  id,
}) => {
  const [periodEndReport] = api.periodEndReport.getById.useSuspenseQuery({
    vehicleId,
    id,
  });

  return <AddEditPeriodEndReport periodEndReport={periodEndReport} />;
};

const AddEditPeriodEndReportWrapper: FC = () => {
  const history = useHistory();
  const { accountingPeriodId, id } = useParams<{
    accountingPeriodId?: string;
    id?: string;
  }>();
  const { selectedVehicleId } = useLayoutContext();
  const vehicleId = selectedVehicleId ?? '';

  useEffect(() => {
    if (!accountingPeriodId && !id) {
      history.push(PERIOD_END_REPORT_LIST);
    }
  }, [accountingPeriodId, id, history]);

  if (accountingPeriodId) {
    return (
      <AddPeriodEndReport
        vehicleId={vehicleId}
        accountingPeriodId={accountingPeriodId}
      />
    );
  }

  if (id) {
    return <EditPeriodEndReport vehicleId={vehicleId} id={id} />;
  }

  return null;
};

export default AddEditPeriodEndReportWrapper;
